import React from 'react';
import { Icon } from '@noths/polaris-design-system-core-components';

import * as styles from './PartnerBadge.styles';

export const PartnerBadge = ({ copy }: { copy?: string }) => (
  <p css={styles.root}>
    <Icon name="topBrand" size="md" /> <strong>Top Brand</strong>
    {copy && <span>{copy}</span>}
  </p>
);
